/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
var ListContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 1.2rem;\n  border-left: ", ";\n  border-right: ", ";\n  padding: 0.928rem 2.856rem 0.928rem 1.428rem;\n  line-height: 1.866rem;\n"], ["\n  display: block;\n  font-size: 1.2rem;\n  border-left: ",
    ";\n  border-right: ",
    ";\n  padding: 0.928rem 2.856rem 0.928rem 1.428rem;\n  line-height: 1.866rem;\n"])), function (_a) {
    var border = _a.border, theme = _a.theme;
    return border ? theme.border : 'none';
}, function (_a) {
    var border = _a.border, theme = _a.theme;
    return border ? theme.border : 'none';
});
ListContent.defaultProps = {
    theme: defaultTheme,
};
export default ListContent;
var templateObject_1;
//# sourceMappingURL=ListContent.js.map